"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBuilder = void 0;
function createBuilder() {
    return class extends Builder {
        constructor(back, root) {
            super(back, root);
        }
    };
}
exports.createBuilder = createBuilder;
class Builder {
    constructor(back, root) {
        this.model = {};
        const proxy = new Proxy(this, {
            get(target, prop, receiver) {
                const existingField = Reflect.get(target, prop);
                if (existingField)
                    return existingField;
                if (prop === 'without') {
                    return (key) => {
                        target.removeField(key);
                        return receiver;
                    };
                }
                if (prop === 'apply') {
                    return (modifier) => {
                        modifier(receiver);
                        return receiver;
                    };
                }
                if (prop === 'setProperties') {
                    return (props) => {
                        target.setFields(props);
                        return receiver;
                    };
                }
                return function (value) {
                    target.setField(prop, value);
                    return receiver;
                };
            }
        });
        this.back = back || proxy;
        this.root = root || proxy;
        this.with = proxy;
        return proxy;
    }
    removeField(key) {
        delete this.model[key];
    }
    setFields(props) {
        Object.assign(this.model, props);
    }
    setField(key, value) {
        Object.assign(this.model, { [key]: value });
    }
    build() {
        return this.model;
    }
}
